import styled from "styled-components";

export const Container = styled.div`
    // width: 90%;
    // position: relative;
    // max-width: 1420px;
    // margin: auto;
    overflow: hidden;
   
    .regulamento h1{
        text-align: left;
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 1.8em;
        letter-spacing: 2px;
        color: #0d5b5b;
    }
    
    .regulamento p{
        font-size: 1em;
        font-weight: 100;
        margin-bottom: 20px;
        line-height: 1.3em;
    }
    .regulamento table {
        border: 1px solid #c9c9c9;
        margin-bottom: 10px;
        max-width: 100%;
        border-collapse: collapse;
    }

    .regulamento table tr th, .regulamento table tr td {
        font-size: 1em;
        color: #58595b;
        padding: 5px 10px;
        white-space: pre-wrap;
        border: 1px solid #c9c9c9;
    }

    .regulamento a {
        color: #58595b;
        display: contents;
        font-size: 1em;
        margin-bottom: 10px;
        font-weight: 500;
        line-height: 1.3em;
        text-decoration: underline;
    }

    .regulamento h3 {
        font-size: 1.3em;
        color: #0d5b5b;
        text-transform: uppercase;
        margin-top: 30px;
        margin-bottom: 10px;
        font-weight: bold;
    }
`;
